module.exports = __webpack_public_path__ + "media/images/Maps-a3ca4dad5d172f581091ae3339d46189.svg";